import { render, staticRenderFns } from "./BannerMenu.vue?vue&type=template&id=319c573b"
import script from "./BannerMenu.vue?vue&type=script&lang=js"
export * from "./BannerMenu.vue?vue&type=script&lang=js"
import style0 from "./BannerMenu.vue?vue&type=style&index=0&id=319c573b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports